export default __webpack_public_path__ + "static/media/icon-file-pdf-empty.7c46580f.svg";